<template>
  <div v-if="model?.visible" class="prompt-modifiers">
    <span>
      <Button
        v-for="prompt in predefinedPrompts"
        :key="prompt.label"
        :model="props.model?.button"
        :alt="prompt.label"
        :text="prompt.label"
        :is-disabled="false"
        @click="handleSelectedPrompt(prompt.text)"
      ></Button>
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { tm } from '../../composables/Translation'
import type { PredefinedPrompt } from '../../types/PredefinedPrompt'
import Button from '../Button.vue'
import type { PredefinedPromptModifiers } from '../../types/configuration/PredefinedPromptModifiers'

const predefinedPrompts = computed(() =>
  tm<PredefinedPrompt[]>('predefinedPromptModifiers.prompts', [])
)

const props = defineProps<{
  model: PredefinedPromptModifiers | undefined
}>()

const emit = defineEmits<{
  (e: 'prompt-selected', text: string): void
}>()

function handleSelectedPrompt(text: string) {
  emit('prompt-selected', text)
}
</script>

<style lang="scss" scoped>
.prompt-modifiers {
  margin-top: 42px;
}

:deep(.button) {
  color: var(--primary-color);
  border-radius: 12px;
  border: 1px solid var(--border-color);
  background: var(--text-background-color);
  margin-right: 12px;
  margin-bottom: 12px;
  font-size: 13px;
  padding: 8px 16px;
  justify-content: center;
  box-sizing: border-box;
}

@media (max-width: 992px) {
  span {
    width: 100%;
  }

  :deep(.button) {
    width: 100%;
  }

  :deep(.button-text) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
